<template lang="pug">
div.password-content
  div.core-region
    div.forget 忘记密码
    div.tips-menu
      ul
        li.title 1、无法访问我的账号？
          p.label 可能你的账号尚未建立或者用户密码错误，请联系指导老师处理。
        li.title 2、忘记账号和密码？
          p.label 请老师帮你修改账号密码。
        li.title 3、没有账号？
          p.label 请老师为你新建账号。
        li.title 4、反馈
          p.label 如果以上方式无法解决您的问题，请通过以下方式联系我们来反馈您的信息，非常感谢！
          p.label 哲寻公司邮箱：find_soft@163.com
      button.back(@click="backlogin") 返回
</template>

<script>
export default {
  methods: {
    backlogin() {
      this.$router.push("/");
    }
  }
};
</script>

<style lang="stylus" scoped>
.password-content
  width 100vw
  height 100vh
  background url('../assets/loginpage/scene_6.png')
  background-size 100vw 100vh
  .core-region
    width 1018px
    height 500px
    margin 0 auto
    position relative
    top 150px
    background rgba(255, 255, 255, 0.91)
    border-radius 8px
    .forget
      text-align right
      padding 42px 70px 46px 0
      font-size 20px
      font-family MicrosoftYaHeiUI
      color rgba(42, 46, 54, 1)
    .tips-menu
      text-align left
      padding-left 80px
      .title
        font-size 16px
        font-family MicrosoftYaHeiUI
        color rgba(42, 46, 54, 1)
        padding-bottom 11px
        .label
          font-size 14px
          font-family MicrosoftYaHeiUI
          color rgba(42, 46, 54, 1)
          padding-left 28px
      .back
        width 101px
        height 40px
        background rgba(56, 133, 225, 1)
        border-radius 4px
        border none
        outline none
        font-size 16px
        font-family MicrosoftYaHeiUI
        color rgba(255, 255, 255, 1)
        margin 61px 0 0 28px
        cursor pointer
</style>
